import React from 'react'
import { useCopyright, CopyrightProps } from './useCopyright'
import styles from './Copyright.module.scss'

const Copyright: React.FC<CopyrightProps> = (props: CopyrightProps) => {
  const { thisYear } = useCopyright(props)

  return (
    <div className={`container ${styles.copyright} text-center mt-4`}>
      <p className='mb-0'>
        © Copyright {thisYear}
        <strong className='px-1 sitename'>
          Lebanese Active Intellect Association
        </strong>
        <span>All Rights Reserved</span>
      </p>
      <div>
        Powered By&nbsp;
        <a
          href='https://www.linkedin.com/company/candledigitals/'
          target='_blank'
          rel='noreferrer'
          className={`text-white fw-bold text-decoration-none transition-0-4 ${styles.link}`}
        >
          Candle Digital Solutions
        </a>
      </div>
    </div>
  )
}

export default Copyright
